import gql from 'graphql-tag';

export const removeLocationMutation = gql`
	mutation RemoveLocation($id: ID!) {
		deleteLocation(id: $id) {
			id
		}
	}
`;
